import { apiClient } from '@app/lib'
import { type ApiResponse, type CognitoMfaSettings } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useChangeMfa = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['changeMfa'],
    mutationFn: async (mfa: CognitoMfaSettings) => {
      const { data } = await apiClient.put<ApiResponse<CognitoMfaSettings>>('/api/mfa', {
        mfa
      })

      return data
    },
    onSuccess: (data) => queryClient.setQueryData(['mfa'], data.data)
  })
}
